import api from 'src/utils/ajax';
import { camelcaseKeys } from 'src/utils/camelize-keys';

import { Session } from './_types';

export const fetchSession = async (baseUrl: string): Promise<Session> => {
  const response = await api.get(`${baseUrl}/api/v5/platforms/current`, {
    withCredentials: true,
  });
  const camelcased = camelcaseKeys(response.data, { deep: true }) as Session;
  return camelcased;
};
